import { createContext } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const defaultContext = {
  transformUrl: url => url,
  transformOptions: (_, _ref) => {
    let {
      body,
      ...otherOptions
    } = _ref;
    return {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify(body),
      ...otherOptions
    };
  },
  transformResponse: res => res,
  transformError: res => res,
  getCache: () => undefined,
  setCache: () => {
    // eslint-disable-next-line no-console
    console.warn('Trying to set cache');
  }
};
const RequestContext = /*#__PURE__*/createContext(defaultContext);

export { RequestContext as default };
//# sourceMappingURL=context.js.map
